/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'SDApplication' store object.
 * @namespace SDApplicationSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UASDApplication';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDApplicationSelectors
   */
  static fetchSdExternaluserApplicationStatus = state =>
    state[selectors.moduleIdentifier].fetchSdExternaluserApplicationStatus.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDApplicationSelectors
   */
  static isFetchingFetchSdExternaluserApplicationStatus = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdExternaluserApplicationStatus.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDApplicationSelectors
   */
  static fetchSdExternaluserApplicationStatusError = state =>
    state[selectors.moduleIdentifier].fetchSdExternaluserApplicationStatusError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDApplicationSelectors
   */
  static fetchSdUserApplicationInfo = state =>
    state[selectors.moduleIdentifier].fetchSdUserApplicationInfo.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDApplicationSelectors
   */
  static isFetchingFetchSdUserApplicationInfo = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdUserApplicationInfo.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDApplicationSelectors
   */
  static fetchSdUserApplicationInfoError = state =>
    state[selectors.moduleIdentifier].fetchSdUserApplicationInfoError.payload;

  /**
   * Selects the data from the store
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDApplicationSelectors
   */
  static iegApplicationType = state => state[selectors.moduleIdentifier].iegApplicationType.payload;
}
